import CustomersItem from "../components/Customers/CustomersItem";
import { customersList } from "../endpoints";
import useFetch from "../hooks/useFetch";
import { useState } from "react";

import { useClickFilter } from "../hooks/filtering";
import { useSearchBar } from "../hooks/search";

interface CustomerData {
  name: string;
}

const CustomerLayout = () => {
  const { data, loading } = useFetch<CustomerData>(customersList);

  const {
    searchEntry,
    setSearchEntry,

    setIsSearchFocused,

    handleFilterClick,
    shouldShowFilters,
    searchRef,
    getFilteredSearchProjects,
  } = useSearchBar(data);
  
  const {
    customerSort,
    toggleCustomerSort,

    getArrow,
    getFilteredData,
  } = useClickFilter();

  // Combine search and click filters
  const getFilteredAndSortedData = () => {
    if (!data) return [];
    
    const searchFiltered = getFilteredSearchProjects();
    
    return getFilteredData(searchFiltered);
  };


  return (
    <div className="overflow-hidden w-full">
      {/* Header */}
      <div>
        <div className="flex justify-between">
          {/* Header Text */}
          <div>
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
              <h1 className="font-bold text-3xl sm:text-4xl">
                {loading ? (
                  <span className="text-gray-400">Klanten laden...</span>
                ) : (
                  `Klanten`
                )}
              </h1>
            </div>
            <p className="mt-4">
              {loading ? (
                <span className="text-gray-400">
                  Een moment geduld, de gegevens worden geladen.
                </span>
              ) : (
                "Hier een overzicht van alle Klanten"
              )}
            </p>
          </div>
          <div className="relative flex-1 flex justify-end" ref={searchRef}>
            {/* Search area */}
            <div className="bg-white w-[50%] h-12 rounded-3xl flex justify-center my-auto border border-gray-200">
              <input
                className="h-6 w-[80%] m-auto focus:outline-none"
                onChange={(e) => setSearchEntry(e.target.value)}
                onFocus={() => setIsSearchFocused(true)}
                value={searchEntry}
                placeholder="Zoeken..."
              />
            </div>

            {/* Filters */}
            {shouldShowFilters && (
              <div className="absolute top-full right-0 z-10 bg-white shadow-lg rounded-lg p-4 border border-gray-200 min-w-[50%] mt-2">
                <b className="text-gray-600 text-xs">Filters</b>
                <div
                  className="text-gray-600 text-sm p-2 cursor-pointer rounded-lg hover:bg-gray-100"
                >
                  <b>Geen specefieke filters mogelijk op het moment</b>
                  <div className="flex text-xs">
                    <b>Zoeken is wel mogelijk</b>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Data Table */}
        <div className="p-8 bg-white  rounded-xl mt-6 w-full overflow-auto">
          {data.length > 0 && !loading && (
            <div className="w-full text-gray-600 flex text-sm p-2 border-b-2">
              <div
                className="w-1/3 flex cursor-pointer select-none"
                onClick={toggleCustomerSort}
              >
                <b>Klant</b>
                {getArrow(customerSort) && (
                  <img
                    src={getArrow(customerSort)!}
                    className="h-5 w-auto ml-1"
                    alt=""
                  />
                )}
              </div>
            </div>
          )}
          {loading ? (
            <div className="min-w-full bg-gray-200 p-4 font-semibold text-gray-700 dark:text-gray-300 rounded-xl mt-1 animate-pulse">
              <p>Klanten laden...</p>
            </div>
          ) : data.length === 0 ? (
            <tr>
              <td
                colSpan={6}
                className="p-4 text-center text-gray-500 text-xl font-semibold"
              >
                Geen klanten
              </td>
            </tr>
          ) : (
            getFilteredAndSortedData().map((customer, index) => (
              <CustomersItem
                key={index}
                name={customer.name}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerLayout;
